module.exports = __webpack_public_path__ + "img/c02_unitcamelrider_Normal_ua.b57ae2ca.webp";